import { Ensemble } from '../types/EnsembleTypes';

// Ensembles prédéfinis pour la recherche
// Deux modes :
//  - 'groupe' : ajoute plusieurs prestations côte à côte (sous-section + prestations)
//  - 'ventilation' : ajoute UNE prestation parente + ses composants en lignes de coût
export const ensemblesPredefinis: Ensemble[] = [
  {
    id: 'bloc-porte-1',
    nom: 'Bloc-Porte Standard',
    description: 'Porte + cadre + quincaillerie',
    categorie: 'menuiserie',
    tags: ['porte', 'cadre', 'quincaillerie'],
    mode: 'groupe',
    sections: [
      {
        id: 'section-bloc-porte',
        nom: 'Bloc-Porte Standard',
        description: 'Ensemble complet pour une porte',
        blocs: [
          {
            id: 'porte-1',
            order: 0,
            level: 0,
            children: [],
            content: {
              titre: 'Porte intérieure standard',
              intitule: 'Porte intérieure standard',
              categorie: 'Menuiserie',
              unite: 'unité',
              prixUnitaire: '150',
              quantite: '1',
              prixTotal: '150',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'cadre-porte-1',
            order: 1,
            level: 0,
            children: [],
            content: {
              titre: 'Cadre de porte',
              intitule: 'Cadre de porte',
              categorie: 'Menuiserie',
              unite: 'unité',
              prixUnitaire: '80',
              quantite: '1',
              prixTotal: '80',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'quincaillerie-porte-1',
            order: 2,
            level: 0,
            children: [],
            content: {
              titre: 'Quincaillerie de porte',
              intitule: 'Quincaillerie de porte',
              categorie: 'Menuiserie',
              unite: 'unité',
              prixUnitaire: '25',
              quantite: '1',
              prixTotal: '25',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          }
        ]
      }
    ],
    dateCreation: new Date('2024-01-15'),
    dateModification: new Date('2024-01-15'),
    auteur: 'Utilisateur',
    version: '1.0'
  },
  {
    id: 'installation-elec-1',
    nom: 'Installation Électrique Basique',
    description: 'Prise + interrupteur + éclairage',
    categorie: 'electricite',
    tags: ['électricité', 'prise', 'interrupteur', 'éclairage'],
    mode: 'groupe',
    sections: [
      {
        id: 'section-elec-basique',
        nom: 'Installation Électrique Basique',
        description: 'Ensemble d\'installation électrique de base',
        blocs: [
          {
            id: 'prise-1',
            order: 0,
            level: 0,
            children: [],
            content: {
              titre: 'Pose de prise électrique',
              intitule: 'Pose de prise électrique',
              categorie: 'Électricité',
              unite: 'unité',
              prixUnitaire: '45',
              quantite: '1',
              prixTotal: '45',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'interrupteur-1',
            order: 1,
            level: 0,
            children: [],
            content: {
              titre: 'Pose d\'interrupteur',
              intitule: 'Pose d\'interrupteur',
              categorie: 'Électricité',
              unite: 'unité',
              prixUnitaire: '35',
              quantite: '1',
              prixTotal: '35',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'eclairage-1',
            order: 2,
            level: 0,
            children: [],
            content: {
              titre: 'Éclairage LED',
              intitule: 'Éclairage LED',
              categorie: 'Électricité',
              unite: 'unité',
              prixUnitaire: '120',
              quantite: '1',
              prixTotal: '120',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          }
        ]
      }
    ],
    dateCreation: new Date('2024-01-15'),
    dateModification: new Date('2024-01-15'),
    auteur: 'Utilisateur',
    version: '1.0'
  },
  {
    id: 'kit-plomberie-1',
    nom: 'Kit Plomberie Salle de Bain',
    description: 'Lavabo + WC + robinetterie',
    categorie: 'plomberie',
    tags: ['plomberie', 'lavabo', 'wc', 'robinetterie'],
    mode: 'groupe',
    sections: [
      {
        id: 'section-plomberie-sdb',
        nom: 'Kit Plomberie Salle de Bain',
        description: 'Ensemble plomberie pour salle de bain',
        blocs: [
          {
            id: 'lavabo-1',
            order: 0,
            level: 0,
            children: [],
            content: {
              titre: 'Lavabo suspendu',
              intitule: 'Lavabo suspendu',
              categorie: 'Plomberie',
              unite: 'unité',
              prixUnitaire: '180',
              quantite: '1',
              prixTotal: '180',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'wc-1',
            order: 1,
            level: 0,
            children: [],
            content: {
              titre: 'WC suspendu',
              intitule: 'WC suspendu',
              categorie: 'Plomberie',
              unite: 'unité',
              prixUnitaire: '250',
              quantite: '1',
              prixTotal: '250',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'robinetterie-1',
            order: 2,
            level: 0,
            children: [],
            content: {
              titre: 'Robinetterie mitigeur',
              intitule: 'Robinetterie mitigeur',
              categorie: 'Plomberie',
              unite: 'unité',
              prixUnitaire: '95',
              quantite: '1',
              prixTotal: '95',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          }
        ]
      }
    ],
    dateCreation: new Date('2024-01-15'),
    dateModification: new Date('2024-01-15'),
    auteur: 'Utilisateur',
    version: '1.0'
  },
  {
    id: 'kit-amenagement-1',
    nom: 'Kit Aménagement Bureau',
    description: 'Cloison + porte + éclairage + prises',
    categorie: 'amenagement',
    tags: ['aménagement', 'cloison', 'bureau', 'éclairage'],
    mode: 'groupe',
    sections: [
      {
        id: 'section-amenagement-bureau',
        nom: 'Kit Aménagement Bureau',
        description: 'Ensemble d\'aménagement pour bureau',
        blocs: [
          {
            id: 'cloison-1',
            order: 0,
            level: 0,
            children: [],
            content: {
              titre: 'Cloison placo',
              intitule: 'Cloison placo',
              categorie: 'Aménagement',
              unite: 'm²',
              prixUnitaire: '45',
              quantite: '12',
              prixTotal: '540',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'porte-bureau-1',
            order: 1,
            level: 0,
            children: [],
            content: {
              titre: 'Porte bureau',
              intitule: 'Porte bureau',
              categorie: 'Aménagement',
              unite: 'unité',
              prixUnitaire: '200',
              quantite: '1',
              prixTotal: '200',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'eclairage-bureau-1',
            order: 2,
            level: 0,
            children: [],
            content: {
              titre: 'Éclairage bureau LED',
              intitule: 'Éclairage bureau LED',
              categorie: 'Aménagement',
              unite: 'unité',
              prixUnitaire: '85',
              quantite: '2',
              prixTotal: '170',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'prises-bureau-1',
            order: 3,
            level: 0,
            children: [],
            content: {
              titre: 'Prises bureau',
              intitule: 'Prises bureau',
              categorie: 'Aménagement',
              unite: 'unité',
              prixUnitaire: '35',
              quantite: '4',
              prixTotal: '140',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          }
        ]
      }
    ],
    dateCreation: new Date('2024-01-15'),
    dateModification: new Date('2024-01-15'),
    auteur: 'Utilisateur',
    version: '1.0'
  },

  // ── Mode ventilation : une prestation + composants détaillés ──
  {
    id: 'ventile-dalle-beton-1',
    nom: 'Dalle béton armé — décomposée',
    description: 'Dalle BA ép. 20 cm ventilée par composant (béton, ferraillage, coffrage, MO)',
    categorie: 'gros-oeuvre',
    tags: ['dalle', 'béton', 'ventilation', 'gros œuvre', 'ba'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-dalle-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'Dalle béton armé ép. 20 cm',
        intitule: 'Dalle béton armé ép. 20 cm',
        categorie: 'Gros œuvre',
        unite: 'm²',
        prixUnitaire: '120',
        quantite: '1',
        prixTotal: '120',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-dalle-beton',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Béton C25/30',
          intitule: 'Béton C25/30 prêt à l\'emploi',
          categorie: 'Gros œuvre',
          unite: 'm³',
          prixUnitaire: '140',
          quantite: '0.2',
          prixTotal: '28'
        }
      },
      {
        id: 'ventile-dalle-ferraillage',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Ferraillage HA',
          intitule: 'Armatures haute adhérence',
          categorie: 'Gros œuvre',
          unite: 'kg',
          prixUnitaire: '1.80',
          quantite: '12',
          prixTotal: '21.6'
        }
      },
      {
        id: 'ventile-dalle-coffrage',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Coffrage',
          intitule: 'Coffrage bois traditionnel',
          categorie: 'Gros œuvre',
          unite: 'm²',
          prixUnitaire: '35',
          quantite: '1',
          prixTotal: '35'
        }
      },
      {
        id: 'ventile-dalle-mo',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Main d\'œuvre coulage + finition',
          categorie: 'Gros œuvre',
          unite: 'h',
          prixUnitaire: '45',
          quantite: '0.8',
          prixTotal: '36'
        }
      }
    ],
    dateCreation: new Date('2025-09-01'),
    dateModification: new Date('2025-09-01'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },
  {
    id: 'ventile-longrine-1',
    nom: 'Longrine béton armé — décomposée',
    description: 'Longrine BA 25×50 ventilée par composant',
    categorie: 'gros-oeuvre',
    tags: ['longrine', 'béton', 'fondation', 'ventilation', 'gros œuvre'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-longrine-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'Longrine BA 25×50',
        intitule: 'Longrine béton armé 25×50 cm',
        categorie: 'Gros œuvre',
        unite: 'ml',
        prixUnitaire: '95',
        quantite: '1',
        prixTotal: '95',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-longrine-beton',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Béton C25/30',
          intitule: 'Béton C25/30 prêt à l\'emploi',
          categorie: 'Gros œuvre',
          unite: 'm³',
          prixUnitaire: '140',
          quantite: '0.125',
          prixTotal: '17.5'
        }
      },
      {
        id: 'ventile-longrine-ferraillage',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Cage d\'armatures',
          intitule: 'Armatures HA façonnées',
          categorie: 'Gros œuvre',
          unite: 'kg',
          prixUnitaire: '1.80',
          quantite: '18',
          prixTotal: '32.4'
        }
      },
      {
        id: 'ventile-longrine-coffrage',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Coffrage',
          intitule: 'Coffrage métallique 2 faces',
          categorie: 'Gros œuvre',
          unite: 'm²',
          prixUnitaire: '28',
          quantite: '1',
          prixTotal: '28'
        }
      },
      {
        id: 'ventile-longrine-mo',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Main d\'œuvre ferraillage + coulage',
          categorie: 'Gros œuvre',
          unite: 'h',
          prixUnitaire: '45',
          quantite: '0.4',
          prixTotal: '18'
        }
      }
    ],
    dateCreation: new Date('2025-09-15'),
    dateModification: new Date('2025-09-15'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },
  {
    id: 'ventile-semelle-filante-1',
    nom: 'Semelle filante — décomposée',
    description: 'Semelle filante BA 60×30 ventilée par composant',
    categorie: 'gros-oeuvre',
    tags: ['semelle', 'filante', 'fondation', 'béton', 'ventilation', 'gros œuvre'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-semelle-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'Semelle filante BA 60×30',
        intitule: 'Semelle filante béton armé 60×30 cm',
        categorie: 'Gros œuvre',
        unite: 'ml',
        prixUnitaire: '85',
        quantite: '1',
        prixTotal: '85',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-semelle-fouille',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Fouille en rigole',
          intitule: 'Terrassement manuel/mécanique',
          categorie: 'Gros œuvre',
          unite: 'm³',
          prixUnitaire: '28',
          quantite: '0.18',
          prixTotal: '5.04'
        }
      },
      {
        id: 'ventile-semelle-beton-proprete',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Béton de propreté',
          intitule: 'Béton maigre sous semelle',
          categorie: 'Gros œuvre',
          unite: 'm²',
          prixUnitaire: '12',
          quantite: '0.6',
          prixTotal: '7.2'
        }
      },
      {
        id: 'ventile-semelle-beton',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Béton C25/30',
          intitule: 'Béton C25/30 prêt à l\'emploi',
          categorie: 'Gros œuvre',
          unite: 'm³',
          prixUnitaire: '140',
          quantite: '0.18',
          prixTotal: '25.2'
        }
      },
      {
        id: 'ventile-semelle-ferraillage',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Chaînage HA',
          intitule: 'Chaînage armatures haute adhérence',
          categorie: 'Gros œuvre',
          unite: 'kg',
          prixUnitaire: '1.80',
          quantite: '14',
          prixTotal: '25.2'
        }
      },
      {
        id: 'ventile-semelle-mo',
        order: 4,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Main d\'œuvre coulage + réglage',
          categorie: 'Gros œuvre',
          unite: 'h',
          prixUnitaire: '45',
          quantite: '0.5',
          prixTotal: '22.5'
        }
      }
    ],
    dateCreation: new Date('2025-09-15'),
    dateModification: new Date('2025-09-15'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },
  {
    id: 'ventile-poteau-ba-1',
    nom: 'Poteau béton armé — décomposé',
    description: 'Poteau BA 25×25 h=2,70 m ventilé par composant',
    categorie: 'gros-oeuvre',
    tags: ['poteau', 'béton', 'structure', 'ventilation', 'gros œuvre'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-poteau-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'Poteau BA 25×25 h=2,70',
        intitule: 'Poteau béton armé 25×25 cm',
        categorie: 'Gros œuvre',
        unite: 'unité',
        prixUnitaire: '180',
        quantite: '1',
        prixTotal: '180',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-poteau-beton',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Béton C25/30',
          intitule: 'Béton C25/30 prêt à l\'emploi',
          categorie: 'Gros œuvre',
          unite: 'm³',
          prixUnitaire: '140',
          quantite: '0.17',
          prixTotal: '23.8'
        }
      },
      {
        id: 'ventile-poteau-ferraillage',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Cage d\'armatures',
          intitule: 'Armatures HA + cadres',
          categorie: 'Gros œuvre',
          unite: 'kg',
          prixUnitaire: '1.90',
          quantite: '22',
          prixTotal: '41.8'
        }
      },
      {
        id: 'ventile-poteau-coffrage',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Coffrage poteau',
          intitule: 'Coffrage métallique 4 faces',
          categorie: 'Gros œuvre',
          unite: 'm²',
          prixUnitaire: '42',
          quantite: '2.7',
          prixTotal: '113.4'
        }
      },
      {
        id: 'ventile-poteau-mo',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Main d\'œuvre coffrage + coulage',
          categorie: 'Gros œuvre',
          unite: 'h',
          prixUnitaire: '45',
          quantite: '1.2',
          prixTotal: '54'
        }
      }
    ],
    dateCreation: new Date('2025-09-15'),
    dateModification: new Date('2025-09-15'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },
  {
    id: 'ventile-mur-banche-1',
    nom: 'Mur banché béton armé — décomposé',
    description: 'Mur banché ép. 20 cm ventilé par composant',
    categorie: 'gros-oeuvre',
    tags: ['mur', 'banché', 'voile', 'béton', 'ventilation', 'gros œuvre'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-mur-banche-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'Mur banché ép. 20 cm',
        intitule: 'Voile béton armé banché 20 cm',
        categorie: 'Gros œuvre',
        unite: 'm²',
        prixUnitaire: '135',
        quantite: '1',
        prixTotal: '135',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-mur-banche-beton',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Béton C25/30',
          intitule: 'Béton C25/30 prêt à l\'emploi',
          categorie: 'Gros œuvre',
          unite: 'm³',
          prixUnitaire: '140',
          quantite: '0.2',
          prixTotal: '28'
        }
      },
      {
        id: 'ventile-mur-banche-ferraillage',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Treillis soudé + HA',
          intitule: 'Armatures treillis soudé + barres HA',
          categorie: 'Gros œuvre',
          unite: 'kg',
          prixUnitaire: '1.75',
          quantite: '15',
          prixTotal: '26.25'
        }
      },
      {
        id: 'ventile-mur-banche-banches',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Location banches',
          intitule: 'Banches métalliques (amortissement)',
          categorie: 'Gros œuvre',
          unite: 'm²',
          prixUnitaire: '22',
          quantite: '2',
          prixTotal: '44'
        }
      },
      {
        id: 'ventile-mur-banche-mo',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Main d\'œuvre montage banches + coulage',
          categorie: 'Gros œuvre',
          unite: 'h',
          prixUnitaire: '45',
          quantite: '0.85',
          prixTotal: '38.25'
        }
      }
    ],
    dateCreation: new Date('2025-09-15'),
    dateModification: new Date('2025-09-15'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },
  {
    id: 'ventile-cloison-ba13-1',
    nom: 'Cloison BA13 — décomposée',
    description: 'Cloison placo 72/48 ventilée par composant',
    categorie: 'amenagement',
    tags: ['cloison', 'placo', 'ba13', 'ventilation', 'second œuvre'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-cloison-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'Cloison BA13 72/48',
        intitule: 'Cloison sèche plâtre 72/48 2 faces',
        categorie: 'Aménagement',
        unite: 'm²',
        prixUnitaire: '48',
        quantite: '1',
        prixTotal: '48',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-cloison-placo',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Plaques BA13',
          intitule: 'Plaques de plâtre 13 mm',
          categorie: 'Aménagement',
          unite: 'm²',
          prixUnitaire: '6',
          quantite: '2',
          prixTotal: '12'
        }
      },
      {
        id: 'ventile-cloison-ossature',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Ossature métallique',
          intitule: 'Rails + montants 48 mm',
          categorie: 'Aménagement',
          unite: 'm²',
          prixUnitaire: '9',
          quantite: '1',
          prixTotal: '9'
        }
      },
      {
        id: 'ventile-cloison-isolant',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Isolant laine minérale',
          intitule: 'Laine de verre 45 mm',
          categorie: 'Aménagement',
          unite: 'm²',
          prixUnitaire: '7',
          quantite: '1',
          prixTotal: '7'
        }
      },
      {
        id: 'ventile-cloison-mo',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Pose + enduit + finition',
          categorie: 'Aménagement',
          unite: 'h',
          prixUnitaire: '40',
          quantite: '0.5',
          prixTotal: '20'
        }
      }
    ],
    dateCreation: new Date('2025-09-01'),
    dateModification: new Date('2025-09-01'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },

  // ── Voile béton armé ép. 18 cm — ventilation Acier / Béton / Coffrage / MO ──
  {
    id: 'ventile-voile-ba-18-1',
    nom: 'Voile béton armé ép. 18 cm — décomposé',
    description: 'Voile BA 18 cm ventilé : béton C30/37 + acier HA + coffrage métallique + MO',
    categorie: 'gros-oeuvre',
    tags: ['voile', 'béton', 'acier', 'coffrage', 'ventilation', 'gros œuvre', 'ba'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-voile-ba-18-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'Voile béton armé ép. 18 cm',
        intitule: 'Voile béton armé ép. 18 cm (F+P)',
        categorie: 'Gros œuvre',
        unite: 'm²',
        prixUnitaire: '70',
        quantite: '1',
        prixTotal: '70',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-voile-ba-18-beton',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Béton C30/37',
          intitule: 'Béton C30/37 prêt à l\'emploi (BPE)',
          categorie: 'Gros œuvre > Béton',
          unite: 'm³',
          prixUnitaire: '145',
          quantite: '0.18',
          prixTotal: '26.10',
          fournisseur: 'Lafarge BPE'
        }
      },
      {
        id: 'ventile-voile-ba-18-acier',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Acier HA Fe500',
          intitule: 'Armatures haute adhérence Fe500 (façonnage compris)',
          categorie: 'Gros œuvre > Acier',
          unite: 'kg',
          prixUnitaire: '1.40',
          quantite: '14',
          prixTotal: '19.60',
          fournisseur: 'Aciéries de France'
        }
      },
      {
        id: 'ventile-voile-ba-18-coffrage',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Coffrage métallique 2 faces',
          intitule: 'Coffrage métallique banches 2 faces (location + montage)',
          categorie: 'Gros œuvre > Coffrage',
          unite: 'm²',
          prixUnitaire: '6',
          quantite: '2',
          prixTotal: '12.00',
          fournisseur: 'PERI Coffrages'
        }
      },
      {
        id: 'ventile-voile-ba-18-mo',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Coulage + vibration + décoffrage',
          categorie: 'Gros œuvre',
          unite: 'h',
          prixUnitaire: '45',
          quantite: '0.3',
          prixTotal: '13.50'
        }
      }
    ],
    dateCreation: new Date('2026-04-26'),
    dateModification: new Date('2026-04-26'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },

  // ── Voile béton armé ép. 25 cm — ventilation Acier / Béton / Coffrage / MO ──
  {
    id: 'ventile-voile-ba-25-1',
    nom: 'Voile béton armé ép. 25 cm — décomposé',
    description: 'Voile BA 25 cm ventilé : béton C30/37 + acier HA + coffrage métallique + MO',
    categorie: 'gros-oeuvre',
    tags: ['voile', 'béton', 'acier', 'coffrage', 'ventilation', 'gros œuvre', 'ba', 'épais'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-voile-ba-25-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'Voile béton armé ép. 25 cm',
        intitule: 'Voile béton armé ép. 25 cm (F+P)',
        categorie: 'Gros œuvre',
        unite: 'm²',
        prixUnitaire: '85',
        quantite: '1',
        prixTotal: '85',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-voile-ba-25-beton',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Béton C30/37',
          intitule: 'Béton C30/37 prêt à l\'emploi (BPE)',
          categorie: 'Gros œuvre > Béton',
          unite: 'm³',
          prixUnitaire: '145',
          quantite: '0.25',
          prixTotal: '36.25',
          fournisseur: 'Cemex Centre'
        }
      },
      {
        id: 'ventile-voile-ba-25-acier',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Acier HA Fe500',
          intitule: 'Armatures haute adhérence Fe500 (densité +)',
          categorie: 'Gros œuvre > Acier',
          unite: 'kg',
          prixUnitaire: '1.40',
          quantite: '18',
          prixTotal: '25.20',
          fournisseur: 'ArcelorMittal IDF'
        }
      },
      {
        id: 'ventile-voile-ba-25-coffrage',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Coffrage métallique 2 faces',
          intitule: 'Coffrage métallique banches 2 faces (location + montage)',
          categorie: 'Gros œuvre > Coffrage',
          unite: 'm²',
          prixUnitaire: '6',
          quantite: '2',
          prixTotal: '12.00',
          fournisseur: 'Doka France'
        }
      },
      {
        id: 'ventile-voile-ba-25-mo',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Coulage + vibration + décoffrage',
          categorie: 'Gros œuvre',
          unite: 'h',
          prixUnitaire: '45',
          quantite: '0.3',
          prixTotal: '13.50'
        }
      }
    ],
    dateCreation: new Date('2026-04-26'),
    dateModification: new Date('2026-04-26'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },

  // ── PBR-1 ép. 23 cm — Plancher porté terre-plein — ventilation Acier/Béton/Coffrage rive + sujétions ──
  {
    id: 'ventile-pbr1-ep23-1',
    nom: 'PBR-1 — Plancher porté terre-plein ép. 23 cm — décomposé',
    description: 'Dallage porté ventilé : béton C25/30 + treillis acier + coffrage rive + hérisson + polyane + MO',
    categorie: 'gros-oeuvre',
    tags: ['dallage', 'pbr', 'plancher', 'béton', 'acier', 'treillis', 'ventilation', 'gros œuvre'],
    mode: 'ventilation',
    prestation: {
      id: 'ventile-pbr1-ep23-parent',
      order: 0,
      level: 0,
      children: [],
      content: {
        titre: 'PBR-1 — Plancher porté sur terre-plein, ép. 23 cm',
        intitule: 'PBR-1 — Plancher porté sur terre-plein, ép. 23 cm (F+P)',
        categorie: 'Gros œuvre',
        unite: 'm²',
        prixUnitaire: '78.95',
        quantite: '1',
        prixTotal: '78.95',
        chantier: 'À définir',
        fournisseur: 'À définir'
      }
    },
    composants: [
      {
        id: 'ventile-pbr1-ep23-beton',
        order: 0,
        level: 0,
        children: [],
        content: {
          titre: 'Béton C25/30',
          intitule: 'Béton C25/30 prêt à l\'emploi (BPE)',
          categorie: 'Gros œuvre > Béton',
          unite: 'm³',
          prixUnitaire: '135',
          quantite: '0.23',
          prixTotal: '31.05',
          fournisseur: 'Holcim Atlantique'
        }
      },
      {
        id: 'ventile-pbr1-ep23-acier',
        order: 1,
        level: 0,
        children: [],
        content: {
          titre: 'Acier — treillis soudé ST25C',
          intitule: 'Treillis soudé ST25C (panneaux 2.4×6 m)',
          categorie: 'Gros œuvre > Acier',
          unite: 'kg',
          prixUnitaire: '1.85',
          quantite: '4',
          prixTotal: '7.40',
          fournisseur: 'Riva Acier'
        }
      },
      {
        id: 'ventile-pbr1-ep23-coffrage',
        order: 2,
        level: 0,
        children: [],
        content: {
          titre: 'Coffrage de rive',
          intitule: 'Coffrage périphérique de rive (planches + étais)',
          categorie: 'Gros œuvre > Coffrage',
          unite: 'ml',
          prixUnitaire: '5',
          quantite: '0.3',
          prixTotal: '1.50',
          fournisseur: 'Hussor Erecta'
        }
      },
      {
        id: 'ventile-pbr1-ep23-herisson',
        order: 3,
        level: 0,
        children: [],
        content: {
          titre: 'Hérisson 0/40',
          intitule: 'Forme drainante hérisson concassé 0/40',
          categorie: 'Gros œuvre',
          unite: 'm³',
          prixUnitaire: '22',
          quantite: '0.10',
          prixTotal: '2.20'
        }
      },
      {
        id: 'ventile-pbr1-ep23-polyane',
        order: 4,
        level: 0,
        children: [],
        content: {
          titre: 'Film polyane',
          intitule: 'Film polyane 200µ — coupure capillaire',
          categorie: 'Gros œuvre',
          unite: 'm²',
          prixUnitaire: '1.20',
          quantite: '1',
          prixTotal: '1.20'
        }
      },
      {
        id: 'ventile-pbr1-ep23-mo',
        order: 5,
        level: 0,
        children: [],
        content: {
          titre: 'Mise en œuvre',
          intitule: 'Pompage béton + tirage + talochage',
          categorie: 'Gros œuvre',
          unite: 'h',
          prixUnitaire: '45',
          quantite: '0.75',
          prixTotal: '33.75'
        }
      }
    ],
    dateCreation: new Date('2026-04-26'),
    dateModification: new Date('2026-04-26'),
    auteur: 'Bibliothèque',
    version: '1.0'
  },

  // ── Préparation de chantier (groupe) ──
  {
    id: 'groupe-prep-chantier-1',
    nom: 'Préparation de chantier — Gros œuvre',
    description: 'Amenée/repli + Implantation + Gestion nappe et eaux',
    categorie: 'gros-oeuvre',
    tags: ['préparation', 'amenée', 'implantation', 'gestion nappe', 'gros œuvre'],
    mode: 'groupe',
    sections: [
      {
        id: 'section-prep-chantier-go',
        nom: 'Préparation chantier',
        description: 'Trois prestations forfaitaires de démarrage',
        blocs: [
          {
            id: 'prep-amenee',
            order: 0,
            level: 0,
            children: [],
            content: {
              titre: 'Amenée / repli',
              intitule: 'Amenée / repli',
              categorie: 'Gros œuvre > Préparation',
              unite: 'ens',
              prixUnitaire: '2500',
              quantite: '1',
              prixTotal: '2500',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'prep-implantation',
            order: 1,
            level: 0,
            children: [],
            content: {
              titre: 'Implantation',
              intitule: 'Implantation des ouvrages par géomètre',
              categorie: 'Gros œuvre > Préparation',
              unite: 'U',
              prixUnitaire: '25',
              quantite: '1',
              prixTotal: '25',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          },
          {
            id: 'prep-nappe',
            order: 2,
            level: 0,
            children: [],
            content: {
              titre: 'Gestion de la nappe et des eaux',
              intitule: 'Gestion de la nappe et des eaux (rabattement, pompage)',
              categorie: 'Gros œuvre > Préparation',
              unite: 'ens',
              prixUnitaire: '2000',
              quantite: '1',
              prixTotal: '2000',
              chantier: 'À définir',
              fournisseur: 'À définir'
            }
          }
        ]
      }
    ],
    dateCreation: new Date('2026-04-26'),
    dateModification: new Date('2026-04-26'),
    auteur: 'Bibliothèque',
    version: '1.0'
  }
];

// Fonction pour obtenir tous les ensembles
export const getAllEnsembles = (): Ensemble[] => {
  return ensemblesPredefinis;
};

// Fonction pour rechercher des ensembles
export const searchEnsembles = (query: string): Ensemble[] => {
  if (query.length < 2) return [];
  
  const searchQuery = query.toLowerCase();
  return ensemblesPredefinis.filter(ensemble => 
    ensemble.nom.toLowerCase().includes(searchQuery) ||
    ensemble.description.toLowerCase().includes(searchQuery) ||
    ensemble.categorie.toLowerCase().includes(searchQuery) ||
    ensemble.tags.some(tag => tag.toLowerCase().includes(searchQuery))
  );
};
